import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { novoDB, triggerLoadNovoDB } from "../dbs/dbsSlice";
import { calculaResultadosLivrudo, carregaLivrudoDB, changeFormBuscaLivro, cleanLivros } from "./LivrudoSlice";
import Table from '@mui/joy/Table';
import Sheet from '@mui/joy/Sheet';
import { Button, Grid, Input, Stack } from '@mui/joy';
import { Link } from "react-router-dom";

function BuscaLivrosPage() {

    var dispatch = useDispatch()
    var loaded = false

    var dbs = useSelector((state) => state.dbs.dbs)
    var livros = useSelector(state => state.livrudo.db.livros)
    var skus = useSelector(state => state.livrudo.db.skus)
    var estados = useSelector(state => state.livrudo.db.estados)
    var form = useSelector(state => state.livrudo.formBuscaLivro)
    if (Object.keys(dbs).includes("livrudo")) {
        loaded = dbs.livrudo.loaded 
    }

    // if(loaded) {
    //     console.log("skus", skus)
    //     console.log("estados", estados)
    // }


    React.useEffect(() => {
        dispatch(triggerLoadNovoDB(
            novoDB("livrudo", 10, "db", (p) => {

                var db = p.payload
                var versao = p.versao

                dispatch(carregaLivrudoDB(db != null ? db : {}))
                dispatch(calculaResultadosLivrudo())
            })
        ))
    }, []);

    function updateSearchQuery(e) {
        dispatch(changeFormBuscaLivro({
            ...form,
            "query" : e.target.value
        }))
    }

    function Carregando() {
        return <Grid container>
            <Grid xs={12} sx={{
                diplay: "flex",
                justifyContent: "center",
                textAlign: "center",
                alignItems: "center"
            }}>
                Experando banco de dados...
            </Grid>
        </Grid>
    }

    return !loaded ? <Carregando /> :
        <Grid container sx={{ padding: "5px 10px" }}>
            <Stack spacing={2}>
                <Stack direction={"row"} spacing={2}>
                    <Input fullWidth={true}
                    onChange={updateSearchQuery} 
                    placeholder="Nome do livro / ISBN"></Input>
                    <Link to="/livrudo/add-livro">
                        <Button > Add </Button>
                    </Link>
                    <Link to="/livrudo/erase" >
                        <Button color="danger"> Erase </Button>
                    </Link>
                </Stack>
                <Sheet>
                    <Table size="md" aria-label="striped table" stripe="2n" >
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th style={{ width: '40%' }}>Nome</th>
                                <th>Categoria</th>
                                <th>Tipo</th>
                            </tr>
                        </thead>
                        <tbody>
                            {livros
                            .filter(f => {
                                if(!form.query || form.query.trim().length == 0) {
                                    return true;
                                } else {
                                    var digit = form.query.replace(/\D/g, '')
                                    var nonDigit = form.query.replace(/[^a-zA-Z]/g, '')
                                    return f.nome.toLowerCase().includes(form.query.toLowerCase())
                                || (nonDigit.length == 0 && digit.length > 0 && f.isbn.includes(digit))
                                }
                            })
                            .map((row) => (
                                <tr key={row.id}>
                                    <td>{row.data}</td>
                                    <td><Link to={"/livrudo/livros/" + row.id}>{row.nome}</Link></td>
                                    <td>{row.categoria}</td>
                                    <td>{row.tipo}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Sheet>
            </Stack>
        </Grid>
}

export default BuscaLivrosPage;